import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { StoreState } from '../store';
import { NotificationsState, actions } from './logic';

interface NotificationHookHandler {
  fetchNotifications(): void;
  readNotification(notification_id: string): void;
  dismissNotification(notification_id: string): void;
  pollNotifications(): void;
}

const useNotificationHook = (): [
  NotificationsState,
  NotificationHookHandler
] => {
  const dispatch = useDispatch();
  const notificationsState = useSelector((s: StoreState) => s['notifications']);

  const handler = React.useMemo(
    () => ({
      fetchNotifications: () => {
        dispatch(actions.fetchNotifications());
      },
      readNotification: (notification_id: string) => {
        dispatch(
          actions.setNotificationStatus({ notification_id, is_read: true })
        );
      },
      dismissNotification: (notification_id: string) => {
        dispatch(
          actions.setNotificationStatus({ notification_id, is_dismissed: true })
        );
      },
      pollNotifications: () => {
        dispatch(actions.pollNotifications());
      },
    }),
    []
  );

  return [notificationsState, handler];
};

export default useNotificationHook;
